// returns a binder for style properties
// the property is camel-cased (backgroundColor); a dashed (background-color) or custom (--x) name works too
export default function style(property, mappingFn) {
  var isDashed = property.indexOf('-') !== -1;
  return {
    on: null,
    getValue: function getValue() {
      if (isDashed) {
        return this.style.getPropertyValue(property) || window.getComputedStyle(this).getPropertyValue(property);
      }
      // a camel-cased name of CSSStyleDeclaration
      return this.style[property] || window.getComputedStyle(this)[property];
    },
    setValue: function setValue(value) {
      var val = typeof mappingFn === 'function' ? mappingFn(value) : value;
      if (!isDashed) {
        this.style[property] = val != null ? val : '';
      } else if (val === null || val === undefined || val === '') {
        this.style.removeProperty(property);
      } else {
        this.style.setProperty(property, val);
      }
    }
  };
}